module.exports = __webpack_public_path__ + "static/janet_harsem-1691e60db599802bdf87a65c6588d99f.png";